module.exports = __webpack_public_path__ + "img/border_Ring2_UP.3094d0e6.svg";